interface SubscribePayload {
  email: string;
  fullName: string;
  phone?: string;
  companyName?: string;
  city?: string;
  partner?: string;
}

export async function subscribeToNewsletter({
  email,
  fullName,
  phone,
  companyName,
  partner,
  city,
}: SubscribePayload): Promise<Response> {
  const res = await fetch("https://events-api.kursiv.media/api/v1/mailchimp/add-member", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      audienceId: "927772b1b7",
      email_address: email,
      status: "subscribed",
      merge_fields: {
        FULLNAME: fullName,
        PHONE: phone,
        COMPANY: companyName,
        PARTNER: partner,
        CITY: city,
      },
    }),
  });

  return res;
}
